import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IconCacheService } from '@finxone-platform/shared/services';
import { baseCssConfigStyle, cssToNgStyle } from '@finxone-platform/shared/sys-config-types';
import Handlebars from 'handlebars';
import { PageConfigurationProvider } from '../../../zones/page-configuration.provider';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-template-list-view',
  templateUrl: './template-list-view.component.html',
  styleUrls: ['./template-list-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemplateListViewComponent implements OnInit {
  private idleTemplateFunction: HandlebarsTemplateDelegate<any>;
  private selectedTemplateFunction: HandlebarsTemplateDelegate<any>;
  @Output() selectedListItem = new EventEmitter<any>();
  @Input() listData: any;
  @Input() idleStateTemplate = '';
  @Input() selectedStateTemplate = '';
  @Input() selectedItemId: string | undefined;
  @Input() baseCssStyle: string;
  @Input() contentStyle: baseCssConfigStyle;
  @Input() noRecordsTemplate: string;
  @Input() gridHeight: number;
  public ulCssStyle: { [key: string]: string };
  public liCssStyle: { [key: string]: string };

  constructor(
    public pageConfig: PageConfigurationProvider,
    private iconCacheService: IconCacheService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.extractStyles();
    this.iconCacheService.iconLoaded$.subscribe(() => {
      this.idleTemplateFunction = Handlebars.compile(this.idleStateTemplate);
      this.selectedTemplateFunction = Handlebars.compile(this.selectedStateTemplate);
      this.cdr.detectChanges();
    });
  }

  public onClickItem(event: any) {
    this.selectedListItem.emit(event);
  }

  private extractStyles() {
    if (this.baseCssStyle) {
      const ulStyleMatch = this.baseCssStyle.match(/ul\s*{([^}]*)}/);
      const liStyleMatch = this.baseCssStyle.match(/li\s*{([^}]*)}/);

      if (ulStyleMatch) {
        this.ulCssStyle = cssToNgStyle(ulStyleMatch[1]);
      }
      if (liStyleMatch) {
        this.liCssStyle = cssToNgStyle(liStyleMatch[1]);
      }
    }
  }

  public renderTemplateItem(item: any): string {
    if (item?.id === this.selectedItemId) {
      return this.selectedTemplateFunction(item);
    } else {
      return this.idleTemplateFunction(item);
    }
  }

  public getContentStyle() {
    return {
      ...this.contentStyle,
      maxHeight: !this.pageConfig?.isUsingHtmlStructure ? this.gridHeight + 'px' : '',
    };
  }
}
